export class LocalesObserver {
    static instance;
    listeners = [];
    preferredLocale = null;
    browserLocale = 'en';
    queryLocale = null;
    static getInstance() {
        if (!Boolean(LocalesObserver.instance)) {
            LocalesObserver.instance = new LocalesObserver();
        }
        return LocalesObserver.instance;
    }
    get() {
        return this.queryLocale ?? this.preferredLocale ?? this.browserLocale;
    }
    setBrowserLocale(browserLocale) {
        this.browserLocale = browserLocale;
        this.notify();
    }
    setQueryLocal(queryLocale) {
        this.queryLocale = queryLocale;
        this.notify();
    }
    setPreferredLocale(preferredLocale) {
        this.preferredLocale = preferredLocale;
        this.notify();
    }
    subscribe(listenerFunc) {
        this.listeners.push(listenerFunc);
        return () => this.unsubscribe(listenerFunc);
    }
    unsubscribe(listenerFunc) {
        this.listeners = this.listeners.filter((listener) => listener !== listenerFunc);
    }
    notify() {
        for (const listener of this.listeners) {
            listener(this.get());
        }
    }
}
//# sourceMappingURL=localesObserver.js.map